import { render, staticRenderFns } from "./changePoint.vue?vue&type=template&id=bc764e08&scoped=true&"
import script from "./changePoint.vue?vue&type=script&lang=js&"
export * from "./changePoint.vue?vue&type=script&lang=js&"
import style0 from "./changePoint.vue?vue&type=style&index=0&id=bc764e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc764e08",
  null
  
)

export default component.exports